
const initialState = {
    languages: [],
};

const languagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_LANGUAGES_NAME":
            return state = {
                ...state,
                languages: [action.payload, ...state.languages ],
            }
        case "UPDATE_LANGUAGES_NAME":
            return state = { ...state, languages: state?.languages?.map((languages) => languages._id === action.payload._id ? action?.payload : languages)}

        case "UPDATE_LANGUAGES_STATUS":
            return state = {
                ...state,
                languages: state?.languages?.map((languages) =>
                    languages._id === action.payload._id ? action?.payload : languages
                ),
            }
            case "GET_ALL_LANGUAGES":
                return {
                    ...state,
                    languages: action.payload,
                };
        default:
            return state;
    }
}

export default languagesReducer;